/* eslint-disable max-len */

/**
 * Иконка календаря для дат
 */
export const CalendarIcon = () => {
  /**
   * Рендер компонента
   */
  const renderContent = () => (
    <svg width='20' height='20' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.1'
            d='M13 2H11V1H10V2H6V1H5V2H3C2.4 2 2 2.4 2 3V13C2 13.6 2.4 14 3 14H13C13.6 14 14 13.6 14 13V3C14 2.4 13.6 2 13 2ZM13 13H3V6H13V13ZM13 5H3V3H5V4H6V3H10V4H11V3H13V5Z'
            fillRule='evenodd'
            clipRule='evenodd' />
    </svg>
  );

  return renderContent();
};
